var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"font-weight-bold custom-legend-label"},[_vm._v("Leyenda de Progreso")]),_c('div',{staticClass:"row"},_vm._l((_vm.items),function(item,key){return _c('div',{key:key,staticClass:"col",class:{
        'pl-2': key !== 0,
        'pr-0': key !== _vm.items.length - 1
      }},[_c('div',{staticClass:"py-1 mb-2",style:({ backgroundColor: item.color })}),_c('p',{staticClass:"fs-13"},[_vm._v(_vm._s(`${item.name}: ${item.description}`))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }